import React from 'react';
import { motion } from 'framer-motion';

const Agents = () => {
  const agents = [
    {
      icon: '📄',
      name: 'Filing Digester Agent',
      description: 'Turns SEC filings into clean summaries.'
    },
    {
      icon: '📢',
      name: 'Event Monitor Agent',
      description: 'Flags news, earnings, and price moves.'
    },
    {
      icon: '🔍',
      name: 'Peer Comp Agent',
      description: 'Benchmarks a company against its competitors.'
    },
    {
      icon: '📊',
      name: 'Model Builder Agent',
      description: 'Creates financial models from historical data.'
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-midnight-navy">
          Meet Your Research Agents.
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {agents.map((agent, index) => (
            <motion.div 
              key={index}
              className="bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="text-4xl text-pale-gold mb-4">{agent.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-midnight-navy">{agent.name}</h3>
              <p className="text-gray-700">{agent.description}</p>
            </motion.div>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <button className="bg-midnight-navy text-white px-6 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-colors inline-flex items-center">
            Explore All Agents
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Agents;
